import * as React from 'react';
import About from './components/About';
import { Benefits } from './components/Benefits';
import Demo from './components/Demo';
import { Terms } from './components/Terms';
import Risks from './components/Risks';

import './index.scss';

interface Props {
  description: string;
}

export const Content: React.FC<Props> = ({ description }) => (
  <div className="stock-landing-content">
    <About description={description} />
    <Benefits />
    <Demo />
    <Terms />
    <Risks />
  </div>
);

export default Content;
